.wrapper
    display: flex
    flex-direction: column
    align-items: flex-start
    padding: 0
    font-size: 12px

.list-item 
    height: 30px
    display: flex
    width: 100%
    padding: 0 10px
    justify-content: space-between
    align-items: center
    cursor: pointer
    border-radius: $globalButtonRounding
    overflow: hidden
    box-sizing: border-box

.selected 
    font-weight: 700

.list-item:hover 
    background-color: rgb($globalSettingsBackgroundSecondary)

/* Radio button styles*/
/* The container */
.container 
    display: flex
    position: relative
    cursor: pointer
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    user-select: none
    align-items: center

/* Hide the browser's default radio button */
.container input
    position: absolute
    opacity: 0
    cursor: pointer

/* Create a custom radio button */
.checkmark 
    position: relative
    height: 17px
    width: 17px
    background: rgb($globalSettingsBackgroundPrimary)
    border-radius: 50%
    border: 2px solid rgb($globalSettingsFontTertiary)
    order: -1
    margin-right: 11px
    transition: all 250ms ease-in-out
    flex-shrink: 0

/* On mouse-over, add a grey background color */
.list-item:hover input ~ .checkmark 
    border-color: rgb($globalSettingsFontPrimary)

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark 
    background-color: rgb($globalSettingsBackgroundPrimary)
    border-color: rgb($globalSettingsFontTertiary)

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after 
    content: ""
    position: absolute
    display: none

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after 
    display: block

.list-item:hover input:checked ~ .checkmark:after 
    border-color: rgb($globalSettingsFontPrimary)

/* Style the indicator (dot/circle) */
.container .checkmark:after 
    left: 5px
    top: 1px
    width: 4px
    height: 10px
    border: solid rgb($globalSettingsFontTertiary)
    border-width: 0 2px 2px 0
    -webkit-transform: rotate(45deg)
    -ms-transform: rotate(45deg)
    transform: rotate(45deg)